import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {LoadingIconSize} from '../../icon/loading-icon/loading-icon.component';

@Component({
  selector: 'awair-shadowed-button',
  templateUrl: './shadowed-button.component.html',
  styleUrls: ['./shadowed-button.component.scss']
})
export class ShadowedButtonComponent implements OnInit {

  LoadingIconSize = LoadingIconSize;

  @HostBinding('class.--disabled') hostDisabled: boolean = false;

  @Input()
  set isDisabled(value: boolean) {
    if (value != null) {
      this.hostDisabled = value;
    }
  }

  @HostBinding('class.--loading') hostLoading: boolean = false;

  @Input()
  set isLoading(value: boolean) {
    if (value != null) {
      this.hostLoading = value;
    }
  }

  constructor() {
  }

  ngOnInit() {
  }
}
